import {
  AuthSignOut,
  SignInViaImpersonateUseCaseInterface,
} from 'domain/usecases';
import Cookies from 'js-cookie';
import { notifyError } from 'presentation/app/components/notify';
import { useAuth } from 'presentation/app/hooks/useAuth';
import { useService } from 'presentation/app/hooks/useService';
import { useFilters } from 'presentation/app/modules/Dashboard/hooks/useFilters';
import { useCallback, useEffect } from 'react';
import Lottie from 'react-lottie';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Badge } from 'reactstrap';

import animationData from '../../../../../../animation/loading.json';
import { getEnv } from 'shared/get-env';

export const SignInViaImpersonate = () => {
  // Constants
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  // Hooks
  const [URLSearchParams] = useSearchParams();
  const token = URLSearchParams.get('token');
  const navigate = useNavigate();
  const { authenticationService } = useService();

  const { clearFilters } = useFilters();
  const { saveAuth, setCurrentUser, currentUser } = useAuth();

  // Methods
  const requestSignOut = useCallback(async (params: AuthSignOut.Params) => {
    await authenticationService
      .authSignOut(params)
      .then(() => {
        console.log('Deslogando o usuário anterior...');
      })
      .catch((error) => {
        console.log('Não foi possível deslogar o usuário anterior.');
      });
  }, []);

  const requestSignInViaImpersonate = useCallback(
    async (params: SignInViaImpersonateUseCaseInterface.Params) => {
      await authenticationService
        .signInViaImpersonate(params)
        .then(({ user }) => {
          saveAuth(user);
          setCurrentUser(user);
          Cookies.set('@rade-gestor/authUser', JSON.stringify(user));
          navigate('/dashboard', { replace: true });
        })
        .catch((err) => {
          notifyError(err.message || 'Não foi possível se autenticar.');
          saveAuth(undefined);
          setCurrentUser(undefined);
          Cookies.remove('@rade-gestor/authUser');
          navigate('/login', { replace: true });
        });
    },
    [],
  );

  const signOutAndSignIn = useCallback(async (isThereACurrentUser: boolean) => {
    if (isThereACurrentUser) {
      saveAuth(undefined);
      setCurrentUser(undefined);
      Cookies.remove('@rade-gestor/authUser');
      clearFilters();
      await requestSignOut();
    }

    requestSignInViaImpersonate({
      token,
    });
  }, []);

  useEffect(() => {
    if (!token) {
      navigate('/login', { replace: true });
    }

    signOutAndSignIn(!!currentUser);
  }, []);

  return (
    <div
      className="d-flex flex-column gap-2 justify-content-center align-items-center p-3"
      style={{
        display: 'flex',
        height: '75svh',
      }}
    >
      <img width={220} src={getEnv('REACT_APP_URL_LOGO')} alt="Logo Rade" />
      <Lottie
        width={200}
        speed={4}
        height={180}
        style={{ cursor: 'default' }}
        options={defaultOptions}
        isClickToPauseDisabled={true}
      />
      <Badge color="primary" className="p-2 fs-5 text-white mb-3">
        RADE Gestor
      </Badge>
      <p className="fs-4 m-0 text-center">
        Por favor, aguarde, estamos o(a) autenticando...
      </p>
    </div>
  );
};
